import React, { useState, useEffect } from "react"
import Modal from "react-modal"
import classNames from "@utils/classnames"

import Button from "@components/button"

const BottomButtons = ({ isEn = false, groupHref, children }) => {
  const [modalIsOpen, setModalIsOpen] = useState(false)
  useEffect(() => {
    Modal.setAppElement(window.document.body)
  }, [])
  return (
    <div className="buttonsContainer">
      <Modal
        width={620}
        isOpen={modalIsOpen}
        overlayClassName="modalOverlay"
        className="modal"
        onRequestClose={() => {
          setModalIsOpen(false)
        }}
      >
        <div className={classNames("box box-white")}>{children()}</div>
      </Modal>
      <Button
        large
        color="blue"
        onClick={() => {
          setModalIsOpen(true)
        }}
      >
        {isEn ? "Register" : "报名参赛"}
      </Button>
      {groupHref && (
        <Button large color="blue" href={groupHref}>
          {isEn ? "Team" : "寻找队伍"}
        </Button>
      )}
    </div>
  )
}

export default BottomButtons
